module.exports = __webpack_public_path__ + "static/media/Jamshed.79e184ba.png";